export default __webpack_public_path__ + "static/O0309-7a86394310559a2c3d210a68b9d93bd9.png";